//#region src/assets/vana-card-logo.svg
var vana_card_logo_default = "" + new URL("vana-card-logo-BePVW8re.svg", import.meta.url).href;
//#endregion
export { vana_card_logo_default as default };

//# sourceMappingURL=vana-card-logo.js.map